import React from 'react';
import { observer } from 'mobx-react';

import routerStore from '@app/src/common/store/RouterStore';
import sidebarStore from '@app/src/common/components/sidebar/SidebarStore';

import { SIDEBAR_ROUTES } from './constants/navigationRoutes';
import NavigationItem from './NavigationItem';

import './Navigation.scss';

const Navigation = () => {
  const navigationRoutes = routerStore.routes
    .filter(route => route.navigationRoute && SIDEBAR_ROUTES[route.path])
    .sort(
      (a, b) => SIDEBAR_ROUTES[a.path].order - SIDEBAR_ROUTES[b.path].order
    );

  return (
    <nav className="navigation">
      <ul className="navigation__list">
        {navigationRoutes.map(route => (
          <li
            key={route.path}
            id={`navigationItem${route.path}`}
            className="navigation__item"
          >
            <NavigationItem
              route={route}
              className="navigation__link"
              location={routerStore.location}
              collapsed={sidebarStore.collapsed}
              {...SIDEBAR_ROUTES[route.path]}
            />
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default observer(Navigation);
